import { useState, useEffect } from 'react';

export default function HomePage() {
  const [socialCount, setSocialCount] = useState(18);
  const [showSocial, setShowSocial] = useState(false);
  const [socialName, setSocialName] = useState('Carlos M.');

  // ── Countdown Timer ──
  const TIMER_KEY = 'nexus_countdown_end';
  const DURATION = 24 * 60 * 60; // 24 hours in seconds

  const getInitialSeconds = () => {
    const stored = localStorage.getItem(TIMER_KEY);
    if (stored) {
      const remaining = Math.floor((parseInt(stored) - Date.now()) / 1000);
      if (remaining > 0) return remaining;
    }
    const end = Date.now() + DURATION * 1000;
    localStorage.setItem(TIMER_KEY, end.toString());
    return DURATION;
  };

  const [timeLeft, setTimeLeft] = useState(getInitialSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          const end = Date.now() + DURATION * 1000;
          localStorage.setItem(TIMER_KEY, end.toString());
          return DURATION;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const hours = String(Math.floor(timeLeft / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((timeLeft % 3600) / 60)).padStart(2, '0');
  const seconds = String(timeLeft % 60).padStart(2, '0');

  const names = ['Carlos M.', 'Lucía R.', 'Andrés P.', 'Valeria T.', 'Miguel S.', 'Sofía L.', 'Diego F.', 'Camila V.'];

  useEffect(() => {
    const timer = setTimeout(() => setShowSocial(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!showSocial) return;
    const interval = setInterval(() => {
      setShowSocial(false);
      setTimeout(() => {
        setSocialCount(prev => prev + 1);
        setSocialName(names[Math.floor(Math.random() * names.length)]);
        setShowSocial(true);
      }, 800);
    }, 7000);
    return () => clearInterval(interval);
  }, [showSocial]);

  const scrollToCheckout = () => {
    const el = document.getElementById('oferta-section');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6]">

      {/* ── Social Proof Toast ── */}
      <div
        className={`fixed bottom-6 left-6 z-[9999] transition-all duration-700 ${
          showSocial ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
      >
        <div className="flex items-center gap-3 bg-white rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.18)] border border-[#E0E0DE] px-4 py-3 max-w-[260px]">
          <div className="relative flex-shrink-0">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#FF6B00] to-[#e05e00] flex items-center justify-center shadow-md">
              <i className="ri-user-fill text-white text-base"></i>
            </div>
            <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-[#25D366] rounded-full border-2 border-white flex items-center justify-center">
              <i className="ri-check-line text-white" style={{ fontSize: '8px' }}></i>
            </div>
          </div>
          <div className="min-w-0">
            <p className="text-xs font-black text-[#0A0A0A] leading-tight">{socialName} acaba de comprar</p>
            <p className="text-xs text-[#FF6B00] font-semibold leading-tight mt-0.5">Nexus IA — $8 ✅</p>
          </div>
        </div>
      </div>

      {/* ── Keyframes via style tag ── */}
      <style>{`
        @keyframes btnPulse {
          0%, 100% { box-shadow: 0 8px 32px rgba(255,107,0,0.55), 0 0 0 0 rgba(255,107,0,0.4); transform: scale(1); }
          50% { box-shadow: 0 12px 48px rgba(255,107,0,0.75), 0 0 0 12px rgba(255,107,0,0); transform: scale(1.025); }
        }
        @keyframes btnBounce {
          0%, 100% { transform: translateY(0) scale(1); }
          30% { transform: translateY(-5px) scale(1.03); }
          60% { transform: translateY(-2px) scale(1.015); }
        }
        .btn-animated {
          animation: btnPulse 2.2s ease-in-out infinite;
        }
        .btn-animated:hover {
          animation: btnBounce 0.5s ease forwards;
        }
        @keyframes textureFade {
          0% { opacity: 0.04; }
          100% { opacity: 0.07; }
        }
        .checkout-card {
          background-color: #ffffff;
          background-image:
            radial-gradient(circle at 1px 1px, rgba(255,107,0,0.12) 1px, transparent 0),
            linear-gradient(135deg, rgba(255,107,0,0.04) 0%, rgba(0,217,255,0.04) 100%);
          background-size: 24px 24px, 100% 100%;
        }
      `}</style>

      {/* Hero Section */}
      <section className="relative min-h-screen w-full overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-top" style={{ backgroundImage: 'url(https://readdy.ai/api/search-image?query=futuristic%20digital%20technology%20network%20with%20glowing%20purple%20and%20blue%20circuit%20patterns%20on%20dark%20background%2C%20abstract%20AI%20neural%20network%20visualization%20with%20interconnected%20nodes%20and%20data%20streams%2C%20cyberpunk%20style%20digital%20intelligence%20backdrop%20with%20neon%20lights%20and%20geometric%20patterns%2C%20high-tech%20artificial%20intelligence%20concept%20with%20flowing%20data%20particles%20and%20holographic%20elements%2C%20sophisticated%20technology%20background%20for%20AI%20software%20platform&width=1920&height=1080&seq=hero-bg-nexus-001&orientation=landscape)' }}></div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>

        {/* Navigation */}
        <nav className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-[#FAF9F6] shadow-md">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-8 h-8 sm:w-9 sm:h-9 bg-[#FF6B00] rounded-lg flex items-center justify-center">
                <i className="ri-cpu-line text-white text-base sm:text-lg"></i>
              </div>
              <span className="text-lg sm:text-xl font-black tracking-tight transition-colors text-[#0A0A0A]">
                Nexus<span className="text-[#FF6B00]"> IA</span>
              </span>
            </div>
            <button onClick={scrollToCheckout} className="px-4 sm:px-6 py-2.5 sm:py-3 bg-[#FF6B00] text-white font-bold rounded-full hover:bg-[#e05e00] transition-all shadow-lg whitespace-nowrap cursor-pointer text-xs sm:text-sm tracking-wide">
              Obtén Acceso — $8
            </button>
          </div>
        </nav>

        {/* Hero Content */}
        <div className="relative z-10 min-h-screen flex items-center">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pt-24 sm:pt-28 pb-16 sm:pb-20">
            <div className="grid lg:grid-cols-2 gap-10 lg:gap-12 items-center">
              <div className="max-w-2xl">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B00]/20 backdrop-blur-sm border border-[#FF6B00]/40 rounded-full mb-5">
                  <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
                  <span className="text-white text-xs sm:text-sm font-semibold tracking-wide">Tecnología Nivel NASA</span>
                </div>
                <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black text-white leading-[1.05] mb-5 sm:mb-6">
                  Nexus IA: <span className="text-[#FF6B00]">La IA que los Gurús</span> no quieren que tengas
                </h1>
                <p className="text-base sm:text-xl text-white/90 leading-relaxed font-light mb-7 sm:mb-8">
                  Identifica <strong className="text-white font-semibold">productos ganadores</strong>, espía nichos rentables y genera <strong className="text-white font-semibold">creativos de nivel profesional</strong> en segundos. <span className="text-[#FF6B00] font-semibold">Solo para los primeros 25 compradores. Precio de lanzamiento.</span>
                </p>
                <button
                  onClick={scrollToCheckout}
                  className="btn-animated group w-full sm:w-auto px-8 sm:px-10 py-5 bg-[#FF6B00] text-white font-black rounded-full cursor-pointer flex items-center justify-center gap-3 sm:gap-4 text-base sm:text-lg mb-7 sm:mb-8 leading-snug text-center whitespace-nowrap"
                >
                  <span>Obtén Acceso Anual — $8</span>
                  <div className="w-9 h-9 sm:w-10 sm:h-10 bg-black/30 rounded-full flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                    <i className="ri-arrow-right-line text-white text-lg sm:text-xl"></i>
                  </div>
                </button>
                <div className="flex flex-wrap items-center gap-4 sm:gap-6">
                  <div className="flex items-center gap-2 text-white/80">
                    <i className="ri-shield-check-fill text-[#FF6B00] text-lg sm:text-xl"></i>
                    <span className="text-xs sm:text-sm font-light">Suscripción Anual</span>
                  </div>
                  <div className="flex items-center gap-2 text-white/80">
                    <i className="ri-time-line text-[#FF6B00] text-lg sm:text-xl"></i>
                    <span className="text-xs sm:text-sm font-light">Acceso Inmediato</span>
                  </div>
                  <div className="flex items-center gap-2 text-white/80">
                    <i className="ri-group-line text-[#FF6B00] text-lg sm:text-xl"></i>
                    <span className="text-xs sm:text-sm font-light">Grupo de Soporte Incluido</span>
                  </div>
                </div>
              </div>

              {/* Video Demo */}
              <div className="relative mt-6 lg:mt-0">
                <div className="absolute inset-0 bg-[#FF6B00]/15 blur-[100px] rounded-full pointer-events-none"></div>
                <div className="relative rounded-2xl overflow-hidden shadow-[0_24px_80px_rgba(0,0,0,0.55),0_0_0_1px_rgba(255,255,255,0.08)]">
                  <div className="flex items-center gap-2 px-3 sm:px-4 py-2.5 sm:py-3 bg-black/60 backdrop-blur-md border-b border-white/10">
                    <div className="flex gap-1.5">
                      <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-[#FF6B00]"></div>
                      <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-white/30"></div>
                      <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-white/30"></div>
                    </div>
                    <div className="flex-1 bg-white/5 rounded-md px-2 sm:px-3 py-1 ml-2 sm:ml-3">
                      <span className="text-white/50 text-xs font-mono">Demo · Nexus Digital Intelligence</span>
                    </div>
                  </div>
                  <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                    <iframe
                      src="https://player.vimeo.com/video/1173062185?badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                      className="absolute inset-0 w-full h-full"
                      frameBorder="0"
                      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                      allowFullScreen
                      title="Nexus IA - Demo"
                    ></iframe>
                  </div>
                </div>
                <div className="absolute -top-6 -right-6 w-20 h-20 sm:w-24 sm:h-24 bg-[#00D9FF]/20 rounded-full blur-2xl animate-pulse pointer-events-none"></div>
                <div className="absolute -bottom-6 -left-6 w-24 h-24 sm:w-32 sm:h-32 bg-[#FF6B00]/20 rounded-full blur-2xl animate-pulse pointer-events-none"></div>
              </div>
            </div>

            {/* Stats */}
            <div className="flex flex-wrap gap-6 sm:gap-12 mt-12 sm:mt-16 pt-8 sm:pt-12 border-t border-white/10">
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#FF6B00]/20 rounded-xl flex items-center justify-center">
                  <i className="ri-search-eye-line text-[#FF6B00] text-xl sm:text-2xl"></i>
                </div>
                <div>
                  <div className="text-xl sm:text-2xl font-black text-white">Análisis</div>
                  <div className="text-xs sm:text-sm text-white/60">de nichos desatendidos</div>
                </div>
              </div>
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#FF6B00]/20 rounded-xl flex items-center justify-center">
                  <i className="ri-image-ai-line text-[#FF6B00] text-xl sm:text-2xl"></i>
                </div>
                <div>
                  <div className="text-xl sm:text-2xl font-black text-white">Creativos</div>
                  <div className="text-xs sm:text-sm text-white/60">generados con IA</div>
                </div>
              </div>
              <div className="flex items-center gap-3 sm:gap-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#FF6B00]/20 rounded-xl flex items-center justify-center">
                  <i className="ri-rocket-line text-[#FF6B00] text-xl sm:text-2xl"></i>
                </div>
                <div>
                  <div className="text-xl sm:text-2xl font-black text-white">$8</div>
                  <div className="text-xs sm:text-sm text-white/60">Solo primeros 25</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Arsenal Section */}
      <section className="py-32 bg-[#FAF9F6]">
        <div className="max-w-7xl mx-auto px-8">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-5 py-2 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-full mb-6">
              <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
              <span className="text-[#FF6B00] text-sm font-bold tracking-wide">TECNOLOGÍA AVANZADA</span>
            </div>
            <h2 className="text-6xl font-black text-[#0A0A0A] leading-tight mb-4">
              El Arsenal de <span className="text-[#FF6B00]">Nexus</span>
            </h2>
            <p className="text-xl text-[#0A0A0A]/70 max-w-3xl mx-auto">
              Tres sistemas de inteligencia artificial trabajando en conjunto para dominar el mercado digital
            </p>
          </div>

          <div className="space-y-24">
            {/* Feature 1 */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-block px-4 py-1.5 bg-white border-2 border-[#E0E0DE] rounded-full mb-4">
                  <span className="text-sm font-bold text-[#0A0A0A]/60">Categoría 1</span>
                </div>
                <h3 className="text-4xl font-black text-[#0A0A0A] mb-3">Inteligencia de Mercado</h3>
                <p className="text-lg font-semibold text-[#FF6B00] mb-4">El Radar que Detecta Oportunidades Ocultas</p>
                <p className="text-base text-[#0A0A0A]/70 leading-relaxed mb-8">
                  Deja de adivinar qué vender. Nuestro sistema de inteligencia artificial escanea miles de nichos en tiempo real para identificar productos digitales con demanda real y baja competencia.
                </p>
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-radar-line text-[#FF6B35] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Análisis de Nichos Desatendidos</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Identifica mercados con alta demanda pero poca oferta de calidad.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-file-search-line text-[#FF6B35] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Detección de Tendencias en PDFs y Descargables</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Escanea qué tipos de productos digitales están generando más búsquedas y conversiones.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-bar-chart-box-line text-[#FF6B35] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Nivel de Competencia Real</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">No solo te muestra el nicho, sino cuántos competidores hay y tu probabilidad real de éxito.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="relative bg-white rounded-3xl border-2 border-[#FF6B35]/30 shadow-[0_8px_32px_rgba(0,0,0,0.08)] overflow-hidden group cursor-pointer hover:shadow-[0_16px_48px_rgba(0,0,0,0.12)] transition-all duration-500">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src="https://public.readdy.ai/ai/img_res/3db5458242cccb2a7a379e56906319d4.jpg" alt="Inteligencia de Mercado" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="absolute top-6 right-6 px-4 py-2 bg-black/80 backdrop-blur-sm rounded-full">
                    <span className="text-white text-xs font-bold">IA AVANZADA</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="lg:order-2">
                <div className="inline-block px-4 py-1.5 bg-white border-2 border-[#E0E0DE] rounded-full mb-4">
                  <span className="text-sm font-bold text-[#0A0A0A]/60">Categoría 2</span>
                </div>
                <h3 className="text-4xl font-black text-[#0A0A0A] mb-3">Ingeniería de Creativos</h3>
                <p className="text-lg font-semibold text-[#FF6B00] mb-4">El Estudio de Diseño que Nunca Duerme</p>
                <p className="text-base text-[#0A0A0A]/70 leading-relaxed mb-8">
                  Genera imágenes publicitarias de alto impacto en segundos. Sin diseñadores, sin Photoshop, sin complicaciones.
                </p>
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#00D9FF]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-image-ai-line text-[#00D9FF] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Generación de Imágenes Publicitarias con IA</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Crea banners, posts para redes sociales y creativos de anuncios con un solo clic.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#00D9FF]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-video-line text-[#00D9FF] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Briefs para Videos de Venta</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Recibe guiones completos y storyboards para tus videos de venta.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#00D9FF]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-layout-grid-line text-[#00D9FF] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Layouts de Alto CTR</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Plantillas de diseño probadas basadas en análisis de miles de campañas exitosas.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:order-1">
                <div className="relative bg-white rounded-3xl border-2 border-[#00D9FF]/30 shadow-[0_8px_32px_rgba(0,0,0,0.08)] overflow-hidden group cursor-pointer hover:shadow-[0_16px_48px_rgba(0,0,0,0.12)] transition-all duration-500">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=creative%20design%20studio%20interface%20showing%20AI-generated%20advertising%20materials%20with%20multiple%20promotional%20graphics%20and%20social%20media%20posts%20displayed%20in%20grid%20layout%2C%20modern%20design%20software%20with%20cyan%20accent%20colors%20featuring%20video%20storyboard%20panels%20and%20high-converting%20ad%20templates%2C%20professional%20marketing%20creative%20workspace%20with%20organized%20visual%20assets%20and%20CTR-optimized%20layouts%2C%20clean%20white%20background%20with%20vibrant%20commercial%20designs&width=900&height=650&seq=arsenal-creativos-002&orientation=landscape" alt="Ingeniería de Creativos" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="absolute top-6 right-6 px-4 py-2 bg-black/80 backdrop-blur-sm rounded-full">
                    <span className="text-white text-xs font-bold">IA AVANZADA</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="inline-block px-4 py-1.5 bg-white border-2 border-[#E0E0DE] rounded-full mb-4">
                  <span className="text-sm font-bold text-[#0A0A0A]/60">Categoría 3</span>
                </div>
                <h3 className="text-4xl font-black text-[#0A0A0A] mb-3">El Arquitecto de Prompts NASA</h3>
                <p className="text-lg font-semibold text-[#FF6B00] mb-4">Prompts de Nivel Profesional al Instante</p>
                <p className="text-base text-[#0A0A0A]/70 leading-relaxed mb-8">
                  Accede a la biblioteca de prompts más avanzada del mercado. Diseñados por ingenieros de IA para obtener respuestas de experto en cualquier tema.
                </p>
                <div className="space-y-6">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-code-s-slash-line text-[#FF6B35] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Prompts Estructurados para ChatGPT/Claude</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Más de 200 prompts profesionales organizados por categoría.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-lightbulb-flash-line text-[#FF6B35] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Eliminación del Bloqueo Creativo</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Nunca más te quedarás sin ideas. Genera contenido original en minutos.</p>
                    </div>
                  </div>
                  <div className="flex gap-4">
                    <div className="w-12 h-12 bg-[#FF6B35]/10 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-brain-line text-[#FF6B35] text-xl"></i>
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-[#0A0A0A] mb-1">Respuestas de Experto Garantizadas</h4>
                      <p className="text-sm text-[#0A0A0A]/70 leading-relaxed">Los prompts incluyen contexto, rol y formato específico para respuestas de consultor senior.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="relative bg-white rounded-3xl border-2 border-[#FF6B35]/30 shadow-[0_8px_32px_rgba(0,0,0,0.08)] overflow-hidden group cursor-pointer hover:shadow-[0_16px_48px_rgba(0,0,0,0.12)] transition-all duration-500">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img src="https://readdy.ai/api/search-image?query=dark%20terminal%20interface%20displaying%20advanced%20AI%20prompt%20engineering%20commands%20with%20glowing%20orange%20text%20on%20black%20background%2C%20professional%20code%20editor%20showing%20structured%20ChatGPT%20prompts%20and%20Claude%20AI%20instructions%2C%20futuristic%20command%20line%20workspace%20with%20organized%20prompt%20library%20categories%20and%20expert-level%20AI%20responses%2C%20sophisticated%20developer%20environment%20with%20monospace%20font%20and%20syntax%20highlighting%20for%20prompt%20templates&width=900&height=650&seq=arsenal-prompts-nasa-003&orientation=landscape" alt="El Arquitecto de Prompts NASA" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700" />
                  </div>
                  <div className="absolute top-6 right-6 px-4 py-2 bg-black/80 backdrop-blur-sm rounded-full">
                    <span className="text-white text-xs font-bold">IA AVANZADA</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-20 text-center">
            <div className="inline-flex flex-col items-center gap-4 px-8 sm:px-12 py-10 bg-gradient-to-br from-[#FF6B00]/5 to-[#00D9FF]/5 border-2 border-[#FF6B00]/20 rounded-3xl w-full sm:w-auto">
              <p className="text-2xl font-bold text-[#0A0A0A]">Los 3 Módulos + Bonos Exclusivos</p>
              <p className="text-5xl font-black text-[#FF6B00]">$8 — Acceso Anual Completo</p>
              <button onClick={scrollToCheckout} className="w-full sm:w-auto px-10 py-5 bg-[#FF6B00] text-white font-black rounded-full shadow-[0_8px_32px_rgba(255,107,0,0.4)] hover:shadow-[0_12px_40px_rgba(255,107,0,0.6)] hover:bg-[#e05e00] transition-all cursor-pointer text-lg leading-snug text-center">
                Acceder Ahora al Arsenal Completo
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Roadmap Section */}
      <section className="py-32 bg-white relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#FF6B00]/5 rounded-full blur-[150px]"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#00D9FF]/5 rounded-full blur-[150px]"></div>
        <div className="max-w-7xl mx-auto px-8 relative z-10">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-2 px-5 py-2 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-full mb-6">
              <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
              <span className="text-[#FF6B00] text-sm font-bold tracking-wide">MÁS QUE UN SOFTWARE</span>
            </div>
            <h2 className="text-6xl font-black text-[#0A0A0A] leading-tight mb-6">
              No Solo Te Damos el <span className="text-[#FF6B00]">Producto</span>,<br />
              Te Damos la <span className="text-[#FF6B00]">Hoja de Ruta</span>
            </h2>
            <p className="text-xl text-[#0A0A0A]/70 max-w-3xl mx-auto leading-relaxed">
              Nexus incluye estrategias completas de venta directa y campañas para WhatsApp. Desde el primer mensaje hasta el cierre, todo está diseñado para <strong className="text-[#0A0A0A] font-semibold">convertir visitantes en clientes</strong>.
            </p>
          </div>
          <div className="grid lg:grid-cols-3 gap-8 mb-16">
            <div className="bg-white rounded-3xl border-2 border-[#FF6B00]/30 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.06)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.1)] transition-all duration-500 group cursor-pointer">
              <div className="w-16 h-16 bg-[#FF6B00]/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-message-3-line text-[#FF6B00] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-black text-[#0A0A0A] mb-2">Copys Persuasivos</h3>
              <p className="text-sm font-semibold text-[#FF6B00] mb-4">Frameworks PAS y AIDA Integrados</p>
              <p className="text-base text-[#0A0A0A]/70 leading-relaxed mb-6">No más bloqueo creativo. Nexus genera copys de venta probados usando las fórmulas más efectivas del marketing directo.</p>
              <div className="space-y-3">
                {['Estructura PAS lista para usar','Modelo AIDA optimizado','Ganchos emocionales que conectan','Llamados a la acción inmediatos'].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#FF6B00] text-lg flex-shrink-0"></i>
                    <p className="text-sm text-[#0A0A0A]/80 leading-snug">{item}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-white rounded-3xl border-2 border-[#25D366]/30 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.06)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.1)] transition-all duration-500 group cursor-pointer">
              <div className="w-16 h-16 bg-[#25D366]/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-whatsapp-line text-[#25D366] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-black text-[#0A0A0A] mb-2">Embudos para WhatsApp</h3>
              <p className="text-sm font-semibold text-[#25D366] mb-4">Configuración Paso a Paso</p>
              <p className="text-base text-[#0A0A0A]/70 leading-relaxed mb-6">Convierte WhatsApp en tu máquina de ventas automática. Desde el primer mensaje hasta el cierre.</p>
              <div className="space-y-3">
                {['Secuencias de mensajes automatizadas','Scripts que manejan objeciones','Estrategias de seguimiento','Plantillas de cierre efectivas'].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#25D366] text-lg flex-shrink-0 mt-0.5"></i>
                    <p className="text-sm text-[#0A0A0A]/80 leading-snug">{item}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-white rounded-3xl border-2 border-[#00D9FF]/30 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.06)] hover:shadow-[0_16px_48px_rgba(0,0,0,0.1)] transition-all duration-500 group cursor-pointer">
              <div className="w-16 h-16 bg-[#00D9FF]/10 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className="ri-user-search-line text-[#00D9FF] text-3xl"></i>
              </div>
              <h3 className="text-2xl font-black text-[#0A0A0A] mb-2">Guías de Segmentación</h3>
              <p className="text-sm font-semibold text-[#00D9FF] mb-4">Encuentra a tu Cliente Ideal</p>
              <p className="text-base text-[#0A0A0A]/70 leading-relaxed mb-6">Deja de vender a todo el mundo. Nexus te muestra exactamente quién necesita tu producto.</p>
              <div className="space-y-3">
                {['Perfiles ICP basados en datos reales','Criterios por comportamiento','Targeting para Facebook e Instagram','Mensajes personalizados por segmento'].map((item, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#00D9FF] text-lg flex-shrink-0 mt-0.5"></i>
                    <p className="text-sm text-[#0A0A0A]/80 leading-snug">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="mt-16 text-center">
            <div className="flex justify-center w-full px-0">
              <a href="https://pay.hotmart.com/N104877725T?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="group w-full sm:w-auto px-8 sm:px-14 py-5 bg-[#0A0A0A] rounded-2xl shadow-[0_12px_40px_rgba(255,107,53,0.45)] hover:bg-[#FF6B35] transition-all duration-300 cursor-pointer flex items-center justify-center gap-3 sm:gap-5 border-2 border-[#FF6B35] hover:border-[#FF6B35] hover:shadow-[0_16px_48px_rgba(255,107,53,0.65)] hover:scale-[1.02]">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-[#FF6B35] group-hover:bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors">
                  <i className="ri-shopping-cart-2-line text-white text-lg sm:text-xl"></i>
                </div>
                <span className="text-white text-base sm:text-lg font-black uppercase tracking-widest leading-snug text-center">Comenzar mi Año de Acceso — $8</span>
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-white/10 group-hover:bg-white/20 rounded-xl flex items-center justify-center flex-shrink-0 transition-colors">
                  <i className="ri-arrow-right-line text-white text-lg sm:text-xl"></i>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Comparison Section */}
      <section className="py-16 sm:py-32 bg-white relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-radial from-[#FF6B00]/5 to-transparent rounded-full blur-3xl"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
          <div className="text-center mb-10 sm:mb-20">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B00]/10 border border-[#FF6B00]/30 rounded-full mb-5">
              <div className="w-2 h-2 bg-[#FF6B00] rounded-full animate-pulse"></div>
              <span className="text-[#FF6B00] text-xs sm:text-sm font-bold tracking-wide">LA DIFERENCIA ES BRUTAL</span>
            </div>
            <h2 className="text-4xl sm:text-6xl font-black text-[#0A0A0A] leading-tight mb-4 sm:mb-6">
              <span className="text-[#FF6B00]">Nexus</span> vs. El Resto
            </h2>
          </div>
          <div className="hidden md:block bg-gradient-to-br from-[#FAF9F6] to-white rounded-3xl border-2 border-[#E0E0DE] shadow-[0_16px_64px_rgba(0,0,0,0.08)] overflow-hidden">
            <div className="grid grid-cols-3 gap-4 p-6 bg-white border-b-2 border-[#E0E0DE]">
              <div className="flex items-center"><span className="text-base font-bold text-[#0A0A0A]/60">Aspecto</span></div>
              <div className="flex justify-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B00]/5 border border-[#FF6B00]/20 rounded-xl">
                  <i className="ri-close-circle-line text-[#FF6B00] text-lg"></i>
                  <span className="text-base font-black text-[#0A0A0A]">Método Tradicional</span>
                </div>
              </div>
              <div className="flex justify-center">
                <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#00D9FF]/10 border border-[#00D9FF]/30 rounded-xl">
                  <i className="ri-checkbox-circle-line text-[#00D9FF] text-lg"></i>
                  <span className="text-base font-black text-[#0A0A0A]">Nexus AI</span>
                </div>
              </div>
            </div>
            <div className="divide-y divide-[#E0E0DE]">
              {[
                { aspect: 'Velocidad de Análisis', traditional: 'Días o semanas investigando manualmente', nexus: 'Resultados en segundos con IA' },
                { aspect: 'Costo de Herramientas', traditional: 'Suscripciones mensuales de $50-$200', nexus: 'Acceso anual por solo $8' },
                { aspect: 'Identificación de Nichos', traditional: 'Basado en adivinanzas y suerte', nexus: 'Datos reales y análisis predictivo' },
                { aspect: 'Creación de Creativos', traditional: 'Contratar diseñadores ($300-$500)', nexus: 'Generación automática con IA' },
                { aspect: 'Estrategias de Venta', traditional: 'Buscar en blogs y videos de YouTube', nexus: 'Copys y embudos listos para usar' },
                { aspect: 'Curva de Aprendizaje', traditional: 'Meses de prueba y error', nexus: 'Implementación inmediata' },
                { aspect: 'Actualizaciones', traditional: 'Pagas cada vez que sale algo nuevo', nexus: 'Actualizaciones durante todo el año incluidas' },
                { aspect: 'Soporte y Comunidad', traditional: 'Estás solo o pagas mentorías caras', nexus: 'Grupo de soporte privado incluido' }
              ].map((row, index) => (
                <div key={index} className="grid grid-cols-3 gap-4 p-5 hover:bg-white/50 transition-colors">
                  <div className="flex items-center"><span className="text-sm font-bold text-[#0A0A0A]">{row.aspect}</span></div>
                  <div className="flex items-center gap-3 bg-[#FF6B00]/5 rounded-xl p-3 border border-[#FF6B00]/10">
                    <i className="ri-close-line text-[#FF6B00] text-xl flex-shrink-0"></i>
                    <p className="text-sm text-[#0A0A0A]/70">{row.traditional}</p>
                  </div>
                  <div className="flex items-center gap-3 bg-[#00D9FF]/5 rounded-xl p-3 border border-[#00D9FF]/20">
                    <i className="ri-check-line text-[#00D9FF] text-xl flex-shrink-0"></i>
                    <p className="text-sm font-semibold text-[#0A0A0A]">{row.nexus}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-10 sm:mt-16 bg-gradient-to-br from-[#FF6B00] to-[#e05e00] rounded-3xl p-8 sm:p-12 shadow-[0_16px_64px_rgba(255,107,0,0.3)] text-center">
            <h3 className="text-2xl sm:text-4xl font-black text-white mb-3 sm:mb-4">La Decisión Más Obvia de Tu Vida</h3>
            <p className="text-base sm:text-xl text-white/90 mb-6 sm:mb-8 leading-relaxed">Puedes seguir perdiendo tiempo y dinero con métodos obsoletos...<br />O puedes unirte a los que ya están <strong className="font-black">dominando el mercado digital con IA</strong>.</p>
            <button onClick={scrollToCheckout} className="w-full sm:w-auto px-10 py-5 bg-white text-[#FF6B00] font-black rounded-full shadow-[0_8px_32px_rgba(0,0,0,0.2)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.3)] hover:scale-105 transition-all cursor-pointer text-base sm:text-xl leading-snug text-center whitespace-normal">
              Sí, Quiero Nexus Ahora — $8
            </button>
          </div>
        </div>
      </section>

      {/* Bonuses Section */}
      <section className="py-16 sm:py-32 bg-white relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 relative z-10">
          <div className="text-center mb-10 sm:mb-16">
            <div className="inline-block px-5 py-2 bg-[#0A0A0A] rounded-full mb-5">
              <span className="text-white text-xs sm:text-sm font-semibold uppercase tracking-wider">Valor Agregado</span>
            </div>
            <h2 className="text-3xl sm:text-5xl font-bold text-[#0A0A0A] mb-3 sm:mb-4 leading-tight">Pack de Bonos Irresistibles</h2>
            <p className="text-base sm:text-xl text-[#666] max-w-2xl mx-auto">Herramientas y recursos adicionales para acelerar tus resultados desde el día uno</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
            {[
              { number: '01', badge: 'EXCLUSIVO', title: 'Lista de 50 Nichos Evergreen', description: 'Nichos probados y validados que generan ingresos consistentes año tras año.', value: 'S/ 197', color: 'border-[#FF6B35]' },
              { number: '02', badge: 'ACCIÓN INMEDIATA', title: 'Masterclass: De 0 a tus primeros S/ 1,000', description: 'Estrategia paso a paso para generar tus primeros mil soles con productos digitales.', value: 'S/ 247', color: 'border-[#00D9FF]' },
              { number: '03', badge: 'ANUAL', title: 'Actualizaciones Anuales al Motor de IA', description: 'Acceso durante todo el año a todas las mejoras y nuevas funcionalidades.', value: 'S/ 497', color: 'border-[#FF6B35]' },
              { number: '04', badge: 'SOLO HOY', title: 'PDF: Guía de Productos Digitales que Más Venden', description: 'Documento exclusivo con los tipos de productos digitales con mayor demanda en Latinoamérica.', value: 'S/ 97', color: 'border-[#00D9FF]' },
              { number: '05', badge: 'NUEVO', title: 'Guía Avanzada: Creación de Imágenes con IA', description: 'La guía más completa para crear imágenes profesionales con inteligencia artificial.', value: 'S/ 197', color: 'border-[#FF6B35]' },
              { number: '06', badge: '🔥 INCLUIDO', title: 'Grupo de Soporte Privado', description: 'Acceso a nuestra comunidad exclusiva donde podrás resolver dudas y recibir apoyo directo del equipo Nexus.', value: 'S/ 297', color: 'border-[#25D366]' }
            ].map((bonus, index) => (
              <div key={index} className={`bg-white rounded-2xl border-2 ${bonus.color} shadow-[0_8px_32px_rgba(0,0,0,0.08)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.15)] transition-all duration-300 p-6 cursor-pointer group relative flex flex-col`}>
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-10">
                  <div className="px-3 py-1 bg-[#FF6B00] rounded-full shadow-lg whitespace-nowrap">
                    <span className="text-white text-xs font-bold uppercase tracking-wider">{bonus.badge}</span>
                  </div>
                </div>
                <div className="text-7xl sm:text-8xl font-black text-[#FF6B00]/10 leading-none select-none mt-4 mb-2">{bonus.number}</div>
                <div className="flex-1 flex flex-col">
                  <h3 className="text-base sm:text-lg font-bold text-[#0A0A0A] mb-2 leading-snug">{bonus.title}</h3>
                  <p className="text-sm text-[#666] leading-relaxed mb-4 flex-1">{bonus.description}</p>
                  <div className="inline-block px-3 py-1.5 bg-[#00D9FF]/10 rounded-lg self-start">
                    <span className="text-xs text-[#00D9FF] font-mono font-bold">Valor: {bonus.value}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-10 sm:mt-16">
            <div className="inline-flex flex-col items-center gap-3 px-8 sm:px-12 py-8 bg-gradient-to-br from-[#FF6B00]/5 to-[#00D9FF]/5 border-2 border-[#FF6B00]/30 rounded-2xl w-full sm:w-auto">
              <p className="text-base text-[#666]">Valor Total de los Bonos:</p>
              <p className="text-4xl sm:text-5xl font-black text-[#FF6B00]">S/ 1,532</p>
              <div className="w-full h-px bg-[#E0E0DE] my-1"></div>
              <p className="text-sm sm:text-base text-[#0A0A0A] font-semibold"><span className="text-[#00D9FF]">Incluidos GRATIS</span> con tu acceso a Nexus</p>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          PRICING / CHECKOUT SECTION — REDISEÑADO
      ══════════════════════════════════════════ */}
      <section id="oferta-section" className="relative min-h-screen w-full flex items-center justify-center overflow-hidden py-20">
        {/* Background image */}
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: 'url(https://readdy.ai/api/search-image?query=modern%20minimalist%20office%20workspace%20with%20laptop%20and%20coffee%20on%20wooden%20desk%20near%20window%20with%20natural%20light%2C%20clean%20professional%20business%20environment%20with%20soft%20shadows%20and%20warm%20tones%2C%20entrepreneur%20workspace%20setup%20with%20notebook%20and%20technology%20devices%2C%20inspiring%20work%20from%20home%20scene%20with%20plants%20and%20organized%20desk%20area%2C%20contemporary%20digital%20nomad%20lifestyle%20background%20with%20blurred%20bokeh%20effect&width=1920&height=1080&seq=pricing-bg-workspace-001&orientation=landscape)' }}></div>
        <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/40 to-black/65"></div>

        <div className="relative z-10 text-center w-full max-w-2xl mx-auto px-4 sm:px-8">
          {/* Scarcity trigger */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF3B30] rounded-full mb-4 animate-pulse">
            <i className="ri-alarm-warning-line text-white text-sm"></i>
            <span className="text-white text-xs font-semibold uppercase tracking-widest">⚠️ Solo quedan cupos para los primeros 25</span>
          </div>

          <div className="flex items-center justify-center gap-2 mb-6">
            <div className="flex -space-x-2">
              {[1,2,3,4,5].map(i => (
                <div key={i} className="w-8 h-8 rounded-full bg-[#FF6B00]/80 border-2 border-white flex items-center justify-center">
                  <i className="ri-user-fill text-white text-xs"></i>
                </div>
              ))}
            </div>
            <span className="text-white/90 text-sm font-semibold ml-1">+{socialCount} personas ya accedieron hoy</span>
          </div>

          <h2 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight drop-shadow-lg">
            Acceso Anual por un<br />Precio Ridículo
          </h2>

          {/* ── COUNTDOWN TIMER ── */}
          <div className="mb-8">
            <p className="text-white/80 text-sm font-semibold uppercase tracking-widest mb-3 flex items-center justify-center gap-2">
              <i className="ri-timer-flash-line text-[#FF3B30] text-lg animate-pulse"></i>
              Este precio expira en:
            </p>
            <div className="flex items-center justify-center gap-2 sm:gap-3">
              {[
                { value: hours, label: 'Horas' },
                { value: minutes, label: 'Minutos' },
                { value: seconds, label: 'Segundos' },
              ].map((unit, i, arr) => (
                <>
                  <div key={unit.label} className="flex flex-col items-center">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 bg-[#FF3B30] rounded-xl flex items-center justify-center shadow-[0_8px_24px_rgba(255,59,48,0.5)] border border-[#FF3B30]/60 relative overflow-hidden">
                      <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none"></div>
                      <span className="text-2xl sm:text-4xl font-black text-white tabular-nums leading-none">{unit.value}</span>
                    </div>
                    <span className="text-white/60 text-[10px] sm:text-xs font-semibold uppercase tracking-wider mt-1.5">{unit.label}</span>
                  </div>
                  {i < arr.length - 1 && (
                    <span key={`sep-${i}`} className="text-white/70 text-3xl sm:text-4xl font-black mb-5 leading-none">:</span>
                  )}
                </>
              ))}
            </div>
          </div>

          {/* ── CHECKOUT CARD con textura ── */}
          <div className="checkout-card rounded-3xl p-6 sm:p-10 shadow-[0_32px_80px_rgba(0,0,0,0.25),0_0_0_1px_rgba(255,107,0,0.15)] mb-8 mx-auto relative overflow-hidden border border-[#FF6B00]/20">
            {/* Decorative corner glow */}
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-[#FF6B00]/10 rounded-full blur-2xl pointer-events-none"></div>
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-[#00D9FF]/10 rounded-full blur-2xl pointer-events-none"></div>

            {/* Urgency bar */}
            <div className="bg-[#FF3B30]/10 border border-[#FF3B30]/30 rounded-xl px-4 py-3 mb-6 flex items-center gap-3 relative z-10">
              <i className="ri-fire-fill text-[#FF3B30] text-xl flex-shrink-0"></i>
              <p className="text-sm font-bold text-[#FF3B30] text-left">Este precio de $8 es EXCLUSIVO para los primeros 25 compradores. Después sube a precio regular.</p>
            </div>

            {/* Price display */}
            <div className="relative z-10">
              <div className="flex items-start justify-center gap-1 mb-1">
                <span className="text-2xl sm:text-4xl text-[#999] font-normal mt-3 sm:mt-4 line-through">$97</span>
              </div>
              <div className="flex items-start justify-center gap-1 mb-4">
                <span className="text-2xl sm:text-4xl text-[#666] font-normal mt-3 sm:mt-4">$</span>
                <span className="text-8xl sm:text-[120px] font-black text-[#FF6B35] leading-none drop-shadow-sm">8</span>
              </div>
              <p className="text-sm sm:text-lg text-[#999] mb-5">Dólares · Acceso por 1 Año completo</p>
              <div className="w-full h-px bg-[#E5E5E3] mb-5"></div>

              {/* Checklist */}
              <div className="space-y-3 text-left max-w-xs mx-auto mb-6">
                {[
                  { icon: 'ri-checkbox-circle-fill', color: 'text-[#00D9FF]', text: 'Acceso Completo por 12 Meses' },
                  { icon: 'ri-checkbox-circle-fill', color: 'text-[#00D9FF]', text: 'Acceso Inmediato al Software' },
                  { icon: 'ri-checkbox-circle-fill', color: 'text-[#00D9FF]', text: 'Actualizaciones Durante el Año' },
                  { icon: 'ri-checkbox-circle-fill', color: 'text-[#00D9FF]', text: '6 Bonos Exclusivos Incluidos' },
                  { icon: 'ri-checkbox-circle-fill', color: 'text-[#25D366]', text: '✅ Grupo de Soporte Privado Incluido', bold: true },
                ].map((item, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <i className={`${item.icon} ${item.color} text-lg flex-shrink-0`}></i>
                    <span className={`text-sm sm:text-base text-[#0A0A0A] ${item.bold ? 'font-bold' : 'font-medium'}`}>{item.text}</span>
                  </div>
                ))}
              </div>

              {/* ── MAIN CTA BUTTON — animated ── */}
              <a
                href="https://pay.hotmart.com/N104877725T?checkoutMode=10"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-animated group w-full flex items-center justify-center gap-3 sm:gap-5 px-8 sm:px-14 py-5 bg-[#FF6B00] rounded-2xl cursor-pointer border-2 border-[#FF6B00] text-white"
              >
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-black/20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-shopping-cart-2-line text-white text-lg sm:text-xl"></i>
                </div>
                <span className="text-white text-base sm:text-lg font-black uppercase tracking-widest leading-snug text-center">
                  Comenzar mi Año de Acceso — $8
                </span>
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-black/20 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-arrow-right-line text-white text-lg sm:text-xl"></i>
                </div>
              </a>
            </div>
          </div>

          <div className="mt-4 flex items-center justify-center gap-2 text-white/90">
            <i className="ri-lock-fill text-lg"></i>
            <span className="text-sm font-light">Pago 100% Seguro y Garantizado</span>
          </div>
          <p className="mt-3 text-white/60 text-xs">Garantía de devolución de 7 días sin preguntas</p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 bg-[#F8F8F6]">
        <div className="max-w-4xl mx-auto px-8">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-[#0A0A0A] mb-4">Preguntas Frecuentes</h2>
            <p className="text-lg text-[#666]">Resolvemos todas tus dudas antes de que tomes la mejor decisión</p>
          </div>
          <div className="space-y-0">
            {['¿Cómo recibo el acceso?','¿Es para principiantes o necesito experiencia previa?','¿Por qué es tan barato? ¿Cuál es el truco?','¿El pago es seguro?'].map((question, index, arr) => (
              <div key={index} className={`bg-white border-b border-[#E5E5E3] ${index === 0 ? 'rounded-t-2xl' : ''} ${index === arr.length - 1 ? 'rounded-b-2xl border-b-0' : ''}`}>
                <button className="w-full px-10 py-8 flex items-center justify-between cursor-pointer hover:bg-[#FAFAF8] transition-colors">
                  <h3 className="text-xl font-semibold text-[#0A0A0A] text-left pr-4">{question}</h3>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 text-[#FF6B35]">
                    <i className="ri-add-line text-3xl font-bold"></i>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A0A0A] relative overflow-hidden">
        <div className="relative z-10 max-w-7xl mx-auto px-8 py-16 flex flex-col items-center text-center">
          <div className="flex items-center gap-3 mb-4">
            <img src="https://public.readdy.ai/ai/img_res/e8d825e9-ac20-4b91-8ab7-2e86d27e2a3d.png" alt="Nexus IA Logo" className="h-10 w-10 object-contain" />
            <span className="text-2xl font-bold text-white">Nexus IA</span>
          </div>
          <p className="text-[#999] text-base mb-2">Inteligencia Artificial para Emprendedores Digitales</p>
          <div className="text-white mb-12">
            <p className="text-3xl font-semibold leading-tight">Domina la Venta de<br /><span className="text-[#FF6B35]">Productos Digitales en Tendencia</span></p>
          </div>
          <div className="w-full h-px bg-[#222] mb-8"></div>
          <div className="flex flex-col sm:flex-row items-center justify-between w-full gap-4">
            <p className="text-sm text-[#666]">© 2025 Nexus IA. Todos los derechos reservados.</p>
            <a href="#" className="text-sm text-[#666] hover:text-[#FF6B35] transition-colors cursor-pointer">Política de Privacidad</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
